<template>
    <div class="statistics-page">
        <div class="contentView">
          <!-- 分数仪表盘 -->
          <div class="contentView-dashboard">
            {{ medalData?.score || 0}}
          </div>
          <!-- 仪表盘描述语 -->
          <div class="contentView-dashTextview">
            <span v-if="medalData?.userRankingData?.pointRank?.ranking && medalData?.userRankingData?.pointRank?.ranking < 101">
                {{ 
                    // eslint-disable-next-line vue/no-parsing-error
                    localesPackage?.['badgewall_statistics_above']?.[localesEnv]?.split("<%>")?.[0]
                }}
                <span class="contentView-dashTextview-bold">
                    {{ 
                        yuliToFix(
                            (
                                (medalData?.useTotalPeople - medalData?.userRankingData?.pointRank?.ranking + 1)
                                / medalData?.useTotalPeople*100
                            )
                            ,2
                        )    
                    }}%
                </span> 
                {{
                    // eslint-disable-next-line vue/no-parsing-error
                    localesPackage?.['badgewall_statistics_above']?.[localesEnv]?.split("<%>")?.[1]
                }}
            </span>
            <span v-else>{{ localesPackage?.['badgewall_statistics_noinrank']?.[localesEnv] }}</span>
          </div>
          <!-- 数据分析区 -->
          <div class="contentView-analysisArea">
            <div class="contentView-analysisArea-title">
                {{ localesPackage?.['badgewall_statistics_label1']?.[localesEnv] }}
            </div>
            <div class="contentView-analysisArea-radar">
                <RadarEchart :RadarData="RadarData"></RadarEchart>
            </div>
            <div class="contentView-analysisArea-title">
                {{ localesPackage?.['badgewall_statistics_label2']?.[localesEnv] }}
                <div class="contentView-analysisArea-title-icon" @click="rankClick">
                    <img class="icon_static" :src="require('@/assets/images/YuliApp/badgeWall/honerPage/icon_static.png')">
                </div>
            </div>
            <div class="contentView-analysisArea-rankDataView">
                <div class="contentView-analysisArea-rankDataView-item">
                    <div class="contentView-analysisArea-rankDataView-item-label">
                        {{ localesPackage?.['badgewall_medal_number']?.[localesEnv] }}
                    </div>
                    <div class="contentView-analysisArea-rankDataView-item-value">
                        {{ 
                            medalData?.userRankingData?.medalRank?.ranking
                            ? (
                                // eslint-disable-next-line vue/no-parsing-error
                                medalData.userRankingData.medalRank.ranking <= 100 
                                ? `No.${medalData?.userRankingData?.medalRank?.ranking}`
                                : (localesPackage?.['badgewall_unranked']?.[localesEnv])
                            ) 
                            : (localesPackage?.['badgewall_unranked']?.[localesEnv])   
                        }}
                    </div>
                </div>
                <div class="contentView-analysisArea-rankDataView-item">
                    <div class="contentView-analysisArea-rankDataView-item-label">
                        {{ localesPackage?.['badgewall_point_rank']?.[localesEnv] }}
                    </div>
                    <div class="contentView-analysisArea-rankDataView-item-value">
                        {{ 
                            medalData?.userRankingData?.pointRank?.ranking 
                            ? (
                                // eslint-disable-next-line vue/no-parsing-error
                                medalData.userRankingData.pointRank.ranking <= 100 
                                ? `No.${medalData?.userRankingData?.pointRank?.ranking}`
                                : localesPackage?.['badgewall_unranked']?.[localesEnv]
                            )  
                            : (localesPackage?.['badgewall_unranked']?.[localesEnv])    
                        }}
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import RadarEchart from "./RadarEchart.vue";
import { toFixedWithMode } from "@/utils/utils.js";

export default {
    components: {
        RadarEchart
    },
    props: {
        DataBase: {
            type: Object,
            default: () => {
                return null
            }
        },
        RadarData: {
            type: Array,
            default: () => {
                return [];
            }
        },
        medalData: {
            type: Object,
            default: () => {
                return null
            }
        },
    },
    computed: {
        ...mapState({
            init: (state) => state.global.init,
            statusBarHeight: (state) => state.global.statusBarHeight,
            languageEnv: (state) => state.global.languageEnv,
            languagePackage: (state) => state.global.languagePackage,
        }),
    },
    watch: {
        languageEnv: {
            async handler(value) {
                if(value){
                this.localesEnv = value;
                }
            },
            immediate: true,
            deep: true,
        },
        languagePackage: {
            async handler(value) {
                if(value){
                this.localesPackage = value;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    setup(props, { emit }) {
        const { cur_kep, total_kep } = props;
        /**语言包 - ref */
        const localesPackage = ref({});
        /**语言环境 - ref */
        const localesEnv = ref('en');

        const rankClick = () => {
            emit('handle', 'rank-open');
        }

        onBeforeMount(()=>{
            appBridging.getStatusBarHeight();
        })

        const yuliToFix = toFixedWithMode;

        return {
            rankClick,
            localesPackage,
            localesEnv,
            yuliToFix,
        };
    },
};
</script>
  
<style lang="less" scoped>
@topHeight: 60px;
@screenTop: 10px;
.statistics-page{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
}
.contentView{
    @fixHeight: 9px;
    margin-top: calc(@topHeight + @screenTop + @fixHeight);
    width: 100%;
    height: calc(100vh - calc(@topHeight + @screenTop + @fixHeight + 52px));
    overflow: scroll;
    box-sizing: border-box;
    &-dashboard{
        width: 163px;
        height: 163px;
        background: url("~@/assets/images/YuliApp/badgeWall/honerPage/dashboard_bg.png") no-repeat
        top left;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffcf52;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 28px;
        font-weight: 600;
        margin: 0 auto;
    }
    &-dashTextview{
        margin: 0 auto;
        margin-top: -2px;
        margin-bottom: 16px;
        color: #3e3838;
        font-family: "PingFang SC";
        font-size: 18px;
        font-weight: 400;
        &-bold{
            color: #8c5d00;
            font-size: 28px;
            font-weight: 600;
        }
    }
    &-analysisArea{
        width: 343px;
        height: 402px;
        background: url("~@/assets/images/YuliApp/badgeWall/honerPage/static_content_bg.png") no-repeat
        top left;
        background-size: 100% 100%;
        padding: 15px 12px;
        margin: 0 auto;
        box-sizing: border-box;
        font-family: "PingFang SC";
        &-title{
            position: relative;
            color: #2c2b2a;
            font-size: 15px;
            line-height: 18px;
            margin-left: 8px;
            text-align: left;
            width: fit-content;
            &::after{
                position: absolute;
                content: '';
                width: 4px;
                height: 16px;
                background: #1F2225;
                top: 0;
                left: -8px;
            }
            &-icon{
                position: absolute;
                top: -2px;
                right: -35px;
                .icon_static{
                    width: 24px;
                    height: 24px;
                }
            }
        }
        &-radar{
            width: 100%;
            // height: 210px;
            margin: 0 auto;
            margin-bottom: 10px;
        }
        &-rankDataView{
            width: 100%;
            padding: 24px 15px;
            box-sizing: border-box;
            &-item{
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                font-family: "PingFang SC";
                &-label{
                    color: #2c2b2a;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 18px
                }
                &-value{
                    color: #634d00;
                    text-align: right;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 18px;
                }
            }
            &-item:nth-child(1){
                margin-bottom: 22px;
            }
        }
    }
}
</style>
  